import angular from "angular"
import "front-end-web-commons"
import "../../bower_components/front-end-web-commons/app/optimization/commonsOptimizationModule"
import "../../bower_components/front-end-web-commons/app/routingConfig/routingConfig"
import "../../bower_components/front-end-web-commons/app/violation/violation"

export default angular.module("optimizationModule", ["nodeCommandsModule", "commonsOptimizationModule", "routingConfigModule", "violationModule"])